import { AxiosInstance } from 'axios';

export abstract class Controller {
  constructor(protected readonly axios: AxiosInstance) {}

  protected composeUrl(path: string, query?: Record<string, unknown>): string {
    const filteredQuery = query
      ? Object.fromEntries(
          Object.entries(query).filter(([, value]) => value !== undefined)
        )
      : query;

    if (!filteredQuery || Object.keys(filteredQuery).length === 0) {
      return path;
    }

    const queryString = Object.entries(filteredQuery)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return value.map((v) => `${key}=${v}`).join('&');
        }

        if (typeof value === 'object' && value !== null) {
          return Object.keys(value)
            .map((key) => `${key}=${(value as Record<string, string>)[key]}`)
            .join('&');
        }

        return `${key}=${value}`;
      })
      .join('&');

    return `${path}?${queryString}`;
  }
}
